import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import RestaurantMenu from '@business/restaurant/RestaurantMenu';
import RestaurantBoxTranslationGenerated from './RestaurantBoxTranslation.generated';
import RestaurantBoxTranslation from '../RestaurantBoxTranslation';


export class RestaurantBoxGeneratedEntityManager<BT extends RestaurantBoxTranslationGenerated, B extends RestaurantBoxGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = RestaurantBoxTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'RestaurantBox',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'restaurantMenu', type: BusinessEntityFieldType.ForeignKey, inputName: 'restaurantMenuId', inputProperty: 'restaurantMenu.id', relatedManager: RestaurantMenu.manager },
				{ name: 'isPromoted', type: BusinessEntityFieldType.Boolean },
				{ name: 'orderNo', type: BusinessEntityFieldType.Integer, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'restaurantBoxes',
            translationsCustomGraphQlFields: 'title,shortDescription,description,info,seoTitle,seoDescription,seoKeywords,slug',
        });
    }

}
export class RestaurantBoxGenerated<BT extends RestaurantBoxTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** Optional. The ID of the RestaurantMenu this box links to. */
	restaurantMenu: RestaurantMenu | null = null;
	/** If true, the box will be displayed on the restaurant page as a promoted box. */
	isPromoted: boolean = false;
	/** The order number of the entity. This is automatically set by the system. The value is updated automatically when the entity is moved up or down in the list. */
	orderNo: number = 0;
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'restaurantBox';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default RestaurantBoxGenerated;